import { render } from "./collectInvoiceJx.vue?vue&type=template&id=6a12c164&scoped=true"
import script from "./collectInvoiceJx.vue?vue&type=script&lang=js"
export * from "./collectInvoiceJx.vue?vue&type=script&lang=js"

import "./collectInvoiceJx.vue?vue&type=style&index=0&id=6a12c164&lang=less&scoped=true"
import "./collectInvoiceJx.vue?vue&type=style&index=1&id=6a12c164&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a12c164"]])

export default __exports__